import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Box, Chip, Divider,
  List, ListItem, ListItemButton, Paper, Typography, TextField, Grid,
  Table, TableContainer, TableCell, TableHead, TableBody, TableRow, TableSortLabel, Tooltip, 
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import { AppHelper } from '../AppHelper';
import SpaCheck from './common/spa-check';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import { ExpandMore, ExpandLess } from "@mui/icons-material";

const dayjs = require('dayjs');

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary" fontSize={"0.7rem"}
          sx={{
            color: props.recSelected==1?'#fff':'text.secondary'
          }}>
          {`${Math.round(props.value)}%`}
          </Typography>
      </Box>
    </Box>
  );
}
function descendingComparator(a, b, orderBy) {
  if (orderBy === "latestTimestamp") {
      return dayjs(a.latestTimestamp).isAfter(dayjs(b.latestTimestamp)) ? -1 : 1;
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsEssay = [
  { id: 'latestTimestamp', numeric: false, disablePadding: false, label: 'TIMESTAMP' },
  { id: 'name', numeric: false, disablePadding: false, label: 'USER' },
  { id: 'logCode', numeric: false, disablePadding: false, label: 'LOG CODE' },
  { id: 'aggregatedRec', numeric: false, disablePadding: false, label: '' },
  { id: 'action', numeric: false, disablePadding: false, label: '' },
 
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const headCells = headCellsEssay ;


  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageSaUserLogList() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();
  
  const [isLoading, setIsLoading] = useState(true);
  const [logList, setLogList] = useState([]);
  
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [expandedUsers, setExpandedUsers] = useState({});

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
	if (startDate && date && date < startDate) {
		setStartDate(date);
	  }
	  else if(!startDate)
	  {
		  setStartDate(date);
	  }
  };
	
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('LIST');
  const [refreshList, setRefreshList] = React.useState(false);
  const [countEssay, setCountLog] = React.useState(0);

  const [tblOrderLog, setTblOrderLog] = React.useState('desc');
  const [tblOrderByLog, setTblOrderByEssay] = React.useState('latestTimestamp');
  const [filterLog, setFilterLog] = React.useState('');

  useEffect(()=>{
    if(!oUser){
      navigate('/login');
      return;
    }
  });

  useEffect(()=>{
    const fetchLogList = async() =>{
      logList.splice(0);
      setIsLoading(true);
      var _res = await AppHelper.apiPost('api/audit/list', {token: oUser.token, startDate:startDate.format("YYYY-MM-DD"), endDate:endDate.format("YYYY-MM-DD")});
      if(!_res || !_res.status){
        setIsLoading(false);
        return;
      }
	  
     _res.data.forEach((row) => {
      var _ts = dayjs(row.timestampUtc);
      row.tTitle = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` + _ts.format('DD MMM YYYY');
      row.logDesc = row.logCode == "RULE-UPDATE"
        ? "Update Scoring Rule"
    : row.logCode == "RULE-UPDATE-SA"
    ? "Update Scoring Rule System"
        : row.logCode == "P-P"
          ? "View Profile Page"
          : row.logCode == "P-SA"
            ? "View SA Page"
            : row.logCode == "P-H"
              ? "View Home Page"
              : row.logCode == "P-ES" 
                ? "View Essay Home Page"
                : row.logCode == "ES-ADD"
                  ? "Submit New Essay"
                  : row.logCode == "P-AI"
                    ? "Accept Invite"
                    : row.logCode == "P-QU"
                      ? "Question List"
                      : row.logCode == "P-CI"
                        ? "Reject Invite"
                        : row.logCode == "ES-DELETE"
                          ? "Delete Essay"
                : row.logCode == "P-SI" 
              ? "Login"
              : row.logCode == "LOGIN" 
              ? "Login"
              : row.logCode == "P-SO" 
              ? "Logout"
              : row.logCode == "EX-ADD" 
              ? "Submit New Exercise"
              : row.logCode == "ES-IMP" 
              ? "Improve Essay"
              : row.logCode == "IMP-DEL" 
              ? "Delete Improve Essay"
                            : "View Essay"
    });
      var _list = [...AppHelper.sortList(_res.data, 'timestamp', 2)];
      const aggregatedData = aggregateLogData(_list);
      setLogList(aggregatedData);
      setCountLog(aggregatedData.length);
      setIsLoading(false);
      
    };
   
		fetchLogList();
  }, [refreshList, startDate, endDate]);
 
  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  const mobileOpenClick = (arg)=>{
    setMobileOpen(!mobileOpen);
  };
  const listSortAndFilterEssay = ()=>{
    var _list = [...logList];
    if(filterLog && filterLog.length>0){
      var _filterText = filterLog.toLowerCase();
      _list = _list.filter(r=>
        r.name.toLowerCase().includes(_filterText)
        || r.logCode.toLowerCase().includes(_filterText)
        || r.logDesc.toLowerCase().includes(_filterText)
        || r.remark?.toLowerCase().includes(_filterText) 
        
      );
    }
    return stableSort(_list, getComparator(tblOrderLog, tblOrderByLog));
  };
  const filterLogChange = (event)=>{
    setFilterLog(event.target.value);
  };
  const visibleLogs = React.useMemo(
    () =>
      listSortAndFilterEssay()
      ,
    [logList, tblOrderLog, tblOrderByLog, filterLog]
  );

  const logsByUser = useMemo(() => {
    const grouped = visibleLogs.reduce((map, rec) => {
      if (!map[rec.name]) {
        map[rec.name] = [];
      }
      map[rec.name].push(rec);
      return map;
    }, {});

    return Object.entries(grouped).sort(([userA], [userB]) => {
      const a = grouped[userA][0];
      const b = grouped[userB][0];
      return getComparator(tblOrderLog, tblOrderByLog)(a, b);
    });
  }, [visibleLogs, tblOrderLog, tblOrderByLog]);

  const tblSortLog = (event, property) => {
    const isAsc = tblOrderByLog === property && tblOrderLog === 'asc';
    setTblOrderLog(isAsc ? 'desc' : 'asc');
    setTblOrderByEssay(property);
  };

  function aggregateLogData(data) {
    const activityList = [];
    let lastKey = null;
  
    const sortedData = [...data].sort((a, b) =>
      dayjs(a.timestampUtc).isAfter(dayjs(b.timestampUtc)) ? -1 : 1
    );
  
    sortedData.forEach((item) => {
      const currentKey = `${item.name}-${item.logCode}`;
  
      if (currentKey !== lastKey) {
        activityList.push({
          name: item.name,
          logCode: item.logCode,
          logDesc: item.logDesc,
          count: 1,
          timestamps: [item.timestampUtc],
          latestTimestamp: item.timestampUtc,
          remark: item.remark
        });
        lastKey = currentKey;
      } else {
        const lastEntry = activityList[activityList.length - 1];
        lastEntry.timestamps.push(item.timestampUtc);
        lastEntry.count++;
        lastEntry.latestTimestamp = item.timestampUtc;
      }
    });
  
    return activityList;
  }

  const toggle = (user) => {
    setExpandedUsers(e => ({ ...e, [user]: !e[user] }));
  }
  
  return (
    <Box sx={{display:'flex'}}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading? (
        <AppLoading />
      ):(
      <>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, 
          width: '100%',
          marginTop:'50px' 
        }}
      >
        
        { viewMode=='LIST' &&
          <>
            <Grid container  spacing={0}>
			   <Grid item xs={3} sm={3}>
				 <Box m={.5} pt={1}>
				<DatePicker sx={{width:'100%'}}
					label="Start Date"
					value={startDate}
					onChange={handleStartDateChange}
					renderInput={(params) => <TextField {...params} />}
				  />
				  </Box>
			  </Grid>
			  <Grid item xs={3} sm={3}>
			   <Box m={.5} pt={1}>
				<DatePicker sx={{width:'100%'}}
					label="End Date"
					value={endDate}
					onChange={handleEndDateChange}
					renderInput={(params) => <TextField {...params} />}
				  />
				 </Box>
			  </Grid>
              <Grid item xs={6} sm={6}>
			   <Box m={.5} pt={1}>
                <TextField value={filterLog} onChange={filterLogChange} id="txtFilterLog" label="" variant="standard" placeholder="Search" fullWidth />
				</Box>
              </Grid>
            </Grid>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <EnhancedTableHead
                  order={tblOrderLog}
                  orderBy={tblOrderByLog}
                  onRequestSort={tblSortLog}
                  rowCount={logList.length}
                  gid='G1'
                />
                <TableBody>

                {/* The row that collapse and show the user name, more detail need to be expand */}
                {logsByUser.map(([user, entries]) => (
                <React.Fragment key={user}>
                  <TableRow>
                    <TableCell>
                    {dayjs(entries[0].latestTimestamp).format(`DD MMM 'YY hh:mm a`).toUpperCase()}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {user}
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell align="center">
                      <IconButton size="small" onClick={() => toggle(user)}>
                        {expandedUsers[user] ? <ExpandLess /> : <ExpandMore />}
                        {entries.length}
                      </IconButton>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>

                  {/* Expanded records for user */}
                  {expandedUsers[user] && entries.map((rec, i) => (
                    <TableRow
                    key={rec.logId}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell>
                      {dayjs(rec.latestTimestamp).format(`DD MMM 'YY hh:mm a`).toUpperCase()}
                      </TableCell>
                      <TableCell align="left">{rec.name}</TableCell>
                      <TableCell>{rec.logDesc}</TableCell>
                      <TableCell>
                        {rec.count > 1 && (
                          <Tooltip
                            arrow
                            title={
                              <div style={{ whiteSpace: 'pre-line' }}>
                                {rec.timestamps.map(ts => 
                                  dayjs(ts).format(`DD MMM 'YY hh:mm a`).toUpperCase()
                                ).join('\n')}
                              </div>
                            }
                          >
                            <Chip
                              label={rec.count}
                              style={{
                                color: 'black', 
                                minWidth: '20px', 
                                height: '25px', 
                                fontSize:'12px', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',  
                              }}
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell>
                      {rec.logCode == "ES-ADD" && 
                        <IconButton
                          href={"/essay/detail/" + rec.remark}
                            target="_blank">
                            <OpenInBrowserIcon></OpenInBrowserIcon>
                        </IconButton>
                      }
                      {rec.logCode == "ES-IMP" && 
                        <IconButton
                          href={"/essay/detail/" + rec.remark}
                            target="_blank">
                            <OpenInBrowserIcon></OpenInBrowserIcon>
                        </IconButton>
                      }
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
                ))}

                </TableBody>
              </Table>
            </TableContainer>
          </>
        }
      </Box>
      </>
      )}
      <SpaCheck></SpaCheck>
    </Box>
  );
}
